// extracted by mini-css-extract-plugin
export default {"preview":"preview-bqVLF","body":"body-IszYY","bodyTitle":"bodyTitle-YwBZG","bodySubTitle":"bodySubTitle-mDpP3"};